
/**
 * Custom component for Bimini cocktail items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-27 (1.0.0) (jhoward)
 *      - <biminiFoodItem> copied to <biminiCocktailItem>.
 *
 *    2024-07-19 (1.0.1) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <bimini-cocktail-item>.
 *
 *    2025-02-11 (1.1.0) (jhoward)
 *      - Add <menu-schedules> to the <bimini-cocktail-item> component if in admin view.
 *      - Add support for scheduling in the <bimini-cocktail-item> component.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *      - Add <menu-item-price> in <bimini-cocktail-item>.
 *      - Remove "visual_" prefix from class names in <bimini-cocktail-item>.
 */

import MenuTag from "../menu-tag.vue";
import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import {computedIsScheduled} from "../../../helpers/menu-sections";
import MenuSchedules from "../schedule/MenuSchedules.vue";
import MenuItemPrice from "./MenuItemPrice.vue";

export default defineComponent({
  name: 'biminiCocktailItem',
  components: {
    MenuItemPrice,
    MenuSchedules,
    MenuTag
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
  computed: {
    containerClasses(): { [key: string]: boolean } {
      return {
        'menu--item-highlighted': this.item.mi_highlight === 1,
        'menu--item-no_price': !this.item.price_display.length,
        'menu--item-no_description': !this.item.mi_description.length,
      };
    },
    isScheduled: computedIsScheduled,
  }
})
